import Vue from "vue";
import Router from "vue-router";
// import Home from "@/views/Home.vue";
import EventList from "@/views/EventList.vue";
import Login from "@/views/Login.vue";
import EventDetail from "@/views/EventDetail.vue";
import TokenService from "@/services/storage.service";

Vue.use(Router);

const router = new Router({
    //mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: EventList,
            meta: {
                // public: true,
                // onlyWhenLoggedOut: false,
                title: "Termine & Anmeldung"
            }
        },
        {
            path: "/reset-pw",
            name: "reset-pw",
            meta: {
                title: 'Passwort erneuern',
                public: true,
                hidden: true
            },
            component: () =>
                import(/* webpackChunkName: "resetpw" */ "@/views/ResetPw.vue")
        },
        {
            path: "/event-list",
            name: "termine",
            meta: {
                title: "Termine",
                hidden: true
            },
            component: () =>
                import(/* webpackChunkName: "eventlist" */ "@/views/EventList.vue")
        },
        {
            path: "/admin",
            name: "admin",
            meta: {
                title: "Lions Club Administration"
            },
            component: () =>
                import(/* webpackChunkName: "admin" */ "@/views/Admin.vue")
        },
        {
            path: "/user-edit/my-profile ",
            name: "my-profile",
            meta: {
                title: "Mein Profil"
            },
            component: () =>
                import(/* webpackChunkName: "user-edit" */ "@/views/UserEdit.vue"),
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                title: "Login",
                public: true,
                onlyWhenLoggedOut: true
            }
        },
        {
            path: "/event/:Id",
            name: "event-detail",
            component: EventDetail,
            meta: {
                title: "Termin Detail",
                hidden: true
            }
        },
        {
            path: "/event-edit/:Id",
            name: "event-edit",
            component: () =>
                import(/* webpackChunkName: "event-edit" */ "@/views/EventEdit.vue"),
            meta: {
                title: "Termin Bearbeiten",
                hidden: true
            }
        },
        {
            path: "/presence/:Id",
            name: "presence",
            component: () =>
                import(/* webpackChunkName: "event-presence" */ "@/views/EventPresence.vue"),
            meta: {
                title: "Anwesenheit",
                hidden: true
            }
        },
        {
            path: "/user-list",
            name: "users",
            meta: {
                title: "Mitglieder",
                hidden: false
            },
            component: () =>
                import(/* webpackChunkName: "user-list" */ "@/views/UserList.vue")
        },
        {
            path: "/event-archive",
            name: "event-archive",
            meta: {
                title: "Terminarchiv",
                hidden: true
            },
            component: () =>
                import(/* webpackChunkName: "events-archive" */ "@/components/EventArchive.vue")
        },
        {
            path: "/user-edit/:Id",
            name: "user-edit",
            component: () =>
                import(/* webpackChunkName: "user-edit" */ "@/views/UserEdit.vue"),
            meta: {
                title: "Mitglied Bearbeiten",
                hidden: true
            }
        },
        {
            path: "/user-view/:Id",
            name: "user-view",
            component: () =>
                import(/* webpackChunkName: "user-edit" */ "@/views/UserView.vue"),
            meta: {
                title: "Mitglied Details",
                hidden: true
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(recoord => recoord.meta.public);
    const onlyWhenLoggedOut = to.matched.some(
        recoord => recoord.meta.onlyWhenLoggedOut
    );
    const loggedIn = !!TokenService.getToken();

    if (!isPublic && !loggedIn) {
        return next({
            path: "/login",
            query: { redirect: to.fullPath }
        });
    }

    // alert(`${isPublic}, ${loggedIn}`)

    if (loggedIn && onlyWhenLoggedOut) {
        return next("/");
    }

    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
    // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = `${process.env.VUE_APP_NAME} | ${nearestWithTitle.meta.title}`;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    next();
});

export default router;
